import {Dialog, DialogContent, Stack, Typography} from "@mui/material";
import type {ModalSystemProps} from "@/global/providers/ModalProvider";
import {apiRejectTicket} from "@/modules/tickets/services/tickets.service";
import {TextFieldForm} from "@/global/components/FormInputs";
import {type SubmitHandler, useForm} from "react-hook-form";
import {z} from "zod";
import {zodRequiredString} from "@/global/types";
import {zodResolver} from "@hookform/resolvers/zod";
import {LoadingButton} from "@mui/lab";
import {toast} from "react-toastify";

interface Props {
    ticketId: number;
}

const zodSchema = z.object({
    message: zodRequiredString,
});

type zodType = z.infer<typeof zodSchema>;

export function TicketReject({open, close, ticketId}: ModalSystemProps<Props>) {

    const {mutate, isPending} = apiRejectTicket();

    const {control, handleSubmit} = useForm<zodType>({
        resolver: zodResolver(zodSchema)
    });

    const onReject: SubmitHandler<zodType> = (data) => {
        mutate({
            ticket_id: ticketId,
            ...data
        }, {
            onSuccess: () => {
                close(0);
                toast.success('Тикет успешно отклонен');
            }
        });
    };

    return (
        <Dialog
            maxWidth={'sm'}
            fullWidth={true}
            open={open}
            onClose={() => close(5)}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '20px'
                }
            }}
        >
            <DialogContent
                sx={{
                    padding: 4,
                    paddingTop: 8,
                }}
            >
                <form onSubmit={handleSubmit(onReject)}>
                    <Stack gap={2}>
                        <Typography
                            color={'#05304F'}
                            textTransform={'uppercase'}
                        >
                            Тикет будет перенаправлен
                        </Typography>
                        <TextFieldForm
                            control={control}
                            name={'message'}
                            placeholder={'Выберите, куда перенаправить'}
                            multiline={true}
                            rows={8}
                        />
                        <LoadingButton
                            loading={isPending}
                            variant={'contained'}
                            type={'submit'}
                            sx={{
                                marginLeft: 'auto',
                            }}
                        >
                            Отклонить
                        </LoadingButton>
                    </Stack>
                </form>
            </DialogContent>
        </Dialog>
    );
}